import { render, staticRenderFns } from "./PullRequest.vue?vue&type=template&id=7c075320"
import script from "./PullRequest.vue?vue&type=script&lang=ts"
export * from "./PullRequest.vue?vue&type=script&lang=ts"
import style0 from "./PullRequest.vue?vue&type=style&index=0&id=7c075320&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports